import * as Constants from "_core/configs/Constants";

// シーン定数
export const SCENE_ACCOUNT       = 'account';
export const SCENE_ADMIN         = 'admin';
export const SCENE_ERROR         = 'error';

// パーツ定数、汎用
export const PARTS_TOP = 'top';

// パーツ定数、アカウント
export const PARTS_ACCOUNT_EDIT                  = 'edit';

// パーツ定数、管理画面
export const PARTS_ADMIN_USEREDIT                = 'useredit';
export const PARTS_ADMIN_USER_ACTION_LOG         = 'useractionlog';
export const PARTS_ADMIN_USER_CHATLOG            = 'userchatlog';
export const PARTS_ADMIN_USER_CHATREPORT         = 'userchatreport';
export const PARTS_ADMIN_USER_INQUIRY_SETTING    = 'userinquirysetting';
export const PARTS_ADMIN_USER_INQUIRY_LOG        = 'userinquirylog';
export const PARTS_ADMIN_USER_PROFILE_EDIT       = 'userprofileedit';
export const PARTS_ADMIN_USER_RAG_STRUCTURE      = 'userragstructure';
export const PARTS_ADMIN_USER_RAG_UPLOAD         = 'userragupload';
export const PARTS_ADMIN_USER_RAG_EVALUATE       = 'userragevaluate';
export const PARTS_ADMIN_USER_RAG_PLAYGROUND     = 'userragplayground';
export const PARTS_ADMIN_USER_MANAGE             = 'usermanage';
export const PARTS_ADMIN_OPS_PROMPT              = 'opsprompt';
export const PARTS_ADMIN_OPS_APPEARANCE          = 'opsappearance';
export const PARTS_ADMIN_OPS_DEMO_PAGE           = 'opsdemopage';
export const PARTS_ADMIN_OPS_CONFIG              = 'opsconfig';
export const PARTS_ADMIN_OPS_TENANT              = 'opstenant';

// 運営ホームテナントの運営（テナント作成を使う人）が使う画面。メニューもこれだけを出し、他の管理画面はテナント作成へ移す
export const OPS_HOME_PARTS = [PARTS_ADMIN_USER_MANAGE, PARTS_ADMIN_USER_ACTION_LOG, PARTS_ADMIN_OPS_TENANT];

// パーツ定数、インフォ
export const PARTS_DETAIL = 'detail';
export const PARTS_POLICY = 'policy';
export const PARTS_PRIVACY_POLICY = 'privacy_policy';

// パーツ定数、エラー
export const PARTS_ERROR_403 = '403';
export const PARTS_ERROR_404 = '404';

// demo
export const SCENE_DEMO_WEB_SOCKET = 'd-websocket';

export const ADMIN_CHECK_SCENE_LIST= [
    "admin",
];

export const PAGES = {
    ACCOUNT_TOP                             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_TOP,
    ADMIN_USER_EDIT                         : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USEREDIT,
    PARTS_ADMIN_USER_CHATLOG                : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_CHATLOG,
    PARTS_ADMIN_USER_PROFILE_EDIT           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_PROFILE_EDIT,
    PARTS_ADMIN_USER_RAG_STRUCTURE          : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_STRUCTURE,
    PARTS_ADMIN_USER_RAG_UPLOAD             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_UPLOAD,
    PARTS_ADMIN_USER_RAG_EVALUATE           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_EVALUATE,
    PARTS_ADMIN_USER_RAG_PLAYGROUND         : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_PLAYGROUND,
    PARTS_ADMIN_USER_CHATREPORT             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_CHATREPORT,
    PARTS_ADMIN_USER_INQUIRY_SETTING        : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_INQUIRY_SETTING,
    PARTS_ADMIN_USER_INQUIRY_LOG            : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_INQUIRY_LOG,
    PARTS_ADMIN_USER_MANAGE                 : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_MANAGE,
    PARTS_ADMIN_USER_ACTION_LOG             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_ACTION_LOG,
    PARTS_ADMIN_OPS_PROMPT                  : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_OPS_PROMPT,
    PARTS_ADMIN_OPS_APPEARANCE              : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_OPS_APPEARANCE,
    PARTS_ADMIN_OPS_DEMO_PAGE               : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_OPS_DEMO_PAGE,
    PARTS_ADMIN_OPS_CONFIG                  : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_OPS_CONFIG,
    PARTS_ADMIN_OPS_TENANT                  : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_OPS_TENANT,
    ERROR_403                               : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ERROR   + "/" + PARTS_ERROR_403,
    ERROR_404                               : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ERROR   + "/" + PARTS_ERROR_404,
};

